import { LocationData } from '@/types/location';

export const fetchUserLocation = async (): Promise<LocationData> => {
  const url = 'https://get.geojs.io/v1/ip/geo.json';

  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Failed to fetch rates: ${response.status} ${response.statusText}`);
  }

  const data = await response.json();

  return data as LocationData;
};
